module.exports = __webpack_public_path__ + "static/media/fp.09a53e07.png";